<template>
  <div class="fixed top-0 bottom-0 left-0 right-0 bg-white" data-cy="app-full-page-message" v-if="fullPageAlertMessage">
    <div class="h-screen p-8 flex flex-col justify-center relative max-w-md mx-auto text-center gap-6">
      <img class="w-20 mx-auto" :src="fullPageAlertMessage.icon" :alt="`${fullPageAlertMessage.title} icon`" />

      <p class="text-3xl font-poppins font-semibold" data-cy="app-full-page-message-title">
        {{ fullPageAlertMessage.title }}
      </p>

      <p v-if="fullPageAlertMessage.body" class="text-xl font-poppins font-normal" data-cy="app-full-page-message-body">
        {{ fullPageAlertMessage.body }}
      </p>

      <button
        @click="fullPageAlertMessage.btnAction"
        class="flex items-center justify-center rounded-full bg-primary-blue text-white px-8 py-4 shadow-md"
        data-cy="app-full-page-message-button"
      >
        {{ fullPageAlertMessage.btnTxt }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AlertType, type AlertMessage, type FullScreenAlertMessage } from '@pi-xcels/utils';
import { computed } from 'vue';

const props = defineProps<{
  alertMessages: Readonly<AlertMessage[]>;
}>();

const fullPageAlertMessage = computed(() =>
  props.alertMessages
    .filter((msg): msg is FullScreenAlertMessage => msg.type === AlertType.FullScreen)
    .sort((a, b) => (a.priority ?? Number.MAX_SAFE_INTEGER) - (b.priority ?? Number.MAX_SAFE_INTEGER))
    .shift()
);
</script>
